import { useQuery } from '@tanstack/react-query';
import { SkillsService } from '../services/skills';
import { IPositionWithSkills } from '../interfaces/position';
import { IBaseUseQueryProps } from '../interfaces/baseUseQueryProps';

export const POSITIONS_WITH_SKILLS_QUERY_KEY = 'get-positions-with-skills';

export const useGetPositionsWithSkills = (props?: IBaseUseQueryProps<IPositionWithSkills[]>) =>
  useQuery({
    queryKey: [POSITIONS_WITH_SKILLS_QUERY_KEY],
    queryFn: () => SkillsService.getPositionsWithSkills(),
    refetchOnWindowFocus: false,
    staleTime: Number.MAX_SAFE_INTEGER,
    ...props
  });